import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["value"]

import { computed, toRef } from 'vue'
    import type { AddProjectsDialogViewModel } from "@Quest/PortfolioScenarios/Components/AddProjectsDialog"

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AddProjectsDialog',
  props: {
    viewModel: {}
  },
  emits: ["selection-confirmed"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // emits
    const emit = __emit

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // derived state
    const opened = computed(() => vm.value?.opened ?? false)

    const statuses = computed(() => vm.value.statuses)
    const lists = computed(() => vm.value.lists)

    // two-way bindings to ViewModel
    const selectedListId = computed<string | null>({
        get: () => vm.value.selectedListId,
        set: v => vm.value.selectedListId = v
    })

    const selectedStatusId = computed<number | null>({
        get: () => vm.value.selectedStatusId,
        set: v => vm.value.selectedStatusId = v
    })

    // methods
    function handleConfirm()
    {
        emit(
            'selection-confirmed',
            vm.value.selectedListId,
            vm.value.selectedStatusId
        )
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Add projects to scenario", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", null, "List:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedListId).value = $event)),
                    class: "form-control"
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, "All", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (l) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: l.Id,
                        value: l.Id
                      }, _toDisplayString(l.Name), 9 /* TEXT, PROPS */, _hoisted_7))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, selectedListId.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Status:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedStatusId).value = $event)),
                    class: "form-control"
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("option", { value: null }, "Any", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.Id,
                        value: s.Id
                      }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_9))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, selectedStatusId.value]
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: handleConfirm,
                  type: "button",
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})